import gql from 'graphql-tag';
export const FETCH_NEIGHBORS_QUERY = gql`
  query VertexQuery($id: String!, $depth: Int) {
    vertex(id: $id) {
      id
      edges {
        id
        fromVertexId
        toVertexId
        relationship {
          displayName
          _class
          _id
          _key
          _type
        }
      }
      entity {
        displayName
        _class
        _id
        _key
        _type
      }
      neighbors(depth: $depth) {
        vertices {
          id
          entity {
            displayName
            _class
            _id
            _key
            _type
          }
        }
        edges {
          id
          fromVertexId
          toVertexId
          relationship {
            displayName
            _class
            _id
            _key
            _type
          }
        }
      }
    }
  }
`;
